import { useSearchFiltersStore } from '@aibees/elephant/feature/search-filters/store';
import { useCompanySearchItemsStore } from '@aibees/elephant/feature/search-table-company/store';
import { ROUTES } from '@aibees/elephant/router';
import { useMemo } from 'react';

export const useCurrentCompanyData = () => {
  const { companySearchItems } = useCompanySearchItemsStore();
  const { selectedItemId } = useSearchFiltersStore();

  const currentItemIndex = useMemo(() => {
    return companySearchItems.findIndex((item) => item.id === selectedItemId);
  }, [companySearchItems, selectedItemId]);

  const fullProfileLink =
    currentItemIndex !== undefined
      ? ROUTES.company.replace(
          ':id',
          String(companySearchItems[currentItemIndex]?.id)
        )
      : '#';

  return {
    currentItemIndex,
    fullProfileLink,
  };
};
